import { useLocation } from "react-router-dom";
import { Box, IconButton, Typography } from "@mui/material";
import { useRef } from "react";
import { FollowUpMessages, FollowUpMessagesRef } from "./FollowUpMessages";
import RefreshIcon from "../../assets/icon/RefreshIcon";

export default function NoShowActivityDetail() {
  const location = useLocation();
  const patient = location.state?.patient;
  const followUpMessagesRef = useRef<FollowUpMessagesRef>(null);

  console.log("[NoShowActivityDetail] Patient data:", patient);
  console.log("[NoShowActivityDetail] Patient ID:", patient?.patientId);
  console.log("[NoShowActivityDetail] Provider ID:", patient?.providerId);

  const handleRefresh = () => {
    console.log("[NoShowActivityDetail] Refresh button clicked");
    followUpMessagesRef.current?.refresh();
  };

  return (
    <Box
      sx={{ width: "100%", padding: "12px 20px", backgroundColor: "#FAFAFA" }}
    >
      {/* Follow-Up Messages Section */}
      {patient?.patientId && patient?.providerId ? (
        <Box>
          <Box
            sx={{
              pb: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 700,
                color: "#2D3748",
                marginBottom: "16px",
                fontFamily: "Quicksand, sans-serif",
              }}
            >
              Follow-Up Messages
            </Typography>

            <IconButton
              onClick={handleRefresh}
              sx={{
                border: "1px solid #E2E8F0",
                borderRadius: "8px",
                padding: "10px",
                "&:hover": {
                  borderColor: "#CBD5E0",
                  backgroundColor: "#F7FAFC",
                },
              }}
            >
              <RefreshIcon style={{ fontSize: "20px", color: "#2D3748" }} />
            </IconButton>
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#718096",
              marginBottom: "16px",
              fontFamily: "Quicksand, sans-serif",
            }}
          >
            Automated messages sent to the patient to encourage rebooking.
            Messages appear 30 and 60 seconds after the no-show record is
            created.
          </Typography>

          <FollowUpMessages
            ref={followUpMessagesRef}
            patientId={patient.patientId}
            providerId={patient.providerId}
            autoRefresh={true}
            refreshInterval={30000}
          />
        </Box>
      ) : (
        <Box
          sx={{
            padding: "40px 20px",
            backgroundColor: "#FFF5F5",
            borderRadius: "8px",
            border: "1px solid #FEB2B2",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: "#C53030",
              fontFamily: "Quicksand, sans-serif",
            }}
          >
            Unable to load follow-up messages: Patient ID or Provider ID is
            missing.
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#718096",
              fontFamily: "Quicksand, sans-serif",
              marginTop: "8px",
            }}
          >
            Patient ID: {patient?.patientId || "Not available"} | Provider ID:{" "}
            {patient?.providerId || "Not available"}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
